import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SystemModuleEnum } from 'src/enumerators';

@Component({
  selector: 'app-info-window-dinamic',
  templateUrl: './info-window-dinamic.component.html',
  styleUrls: ['./info-window-dinamic.component.css'],
})
export class InfoWindowDinamicComponent implements OnInit {

  @Input() element: any;
  @Input() type: SystemModuleEnum;

  systemModuleEnum = SystemModuleEnum;

  constructor() { }

  ngOnInit() {
  }

}
